import { PayPalEcStatesEnum } from 'i2g-ng-payment';
import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../../utils/helpers/model.helper';
import { AchDebit } from './ach-debit.model';
import { CardPayments } from './card-payments.model';

export const PAYMENTS_SETTINGS_SCHEMA = Object.freeze({
  ACH_DEBIT: AchDebit,
  ALLOWED_BY_PARTNER: false,
  AVAILABLE_CARD_TYPES: List<string>(),
  CARD_PAYMENT_FEES_DESCRIPTION: '',
  ELIGIBLE_FOR_FEE_PASS_THROUGH: false,
  ENABLED_BY_USER: false,
  FEE_PASS_THROUGH_ENABLED: false,
  FPT_FEES_DESCRIPTION: '',
  KYC_COMPLETE: false,
  PAYPAL_EC_EMAIL: '',
  PAYPAL_EC_ENABLED: false,
  PAYPAL_EC_STATUS: false,
  PAYPAL_ONBOARDING_URL: '',
  UNDERWRITING_COUNTRY: '',
  UNDERWRITING_CURRENCY: '',
  UNDERWRITING_URL: '',
  CARD_PAYMENTS: CardPayments,
  TIP_ENABLED: false,
});
const RECORD = generateSchema(PAYMENTS_SETTINGS_SCHEMA);
const KEYS: any = generateKeys(PAYMENTS_SETTINGS_SCHEMA);

export class PaymentsSettings extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    return setInModel(this, [
      {
        key: KEYS.ACH_DEBIT,
        value: new AchDebit(this.achDebit),
      },
      {
        key: KEYS.CARD_PAYMENTS,
        value: new CardPayments(this.cardPayments),
      },
    ]) as PaymentsSettings;
  }

  get achDebit(): AchDebit {
    return this.get(KEYS.ACH_DEBIT);
  }

  /** @deprecated by https://invoice2go.atlassian.net/browse/PEG-3217.
   * Replaced by this.cardPayments.stripe **/
  get allowedByPartner(): boolean {
    return this.get(KEYS.ALLOWED_BY_PARTNER);
  }

  get availableCardTypes(): List<string> {
    return this.get(KEYS.AVAILABLE_CARD_TYPES);
  }

  get cardFeesDescription(): string {
    return this.get(KEYS.CARD_PAYMENT_FEES_DESCRIPTION);
  }

  get eligibleForFPT(): boolean {
    return this.get(KEYS.ELIGIBLE_FOR_FEE_PASS_THROUGH);
  }

  /** @deprecated by https://invoice2go.atlassian.net/browse/PEG-3217.
   * Replaced by this.cardPayments.stripe **/
  get enabledByUser(): boolean {
    return this.get(KEYS.ENABLED_BY_USER);
  }

  get fptEnabled(): boolean {
    return this.get(KEYS.FEE_PASS_THROUGH_ENABLED);
  }

  get fptFeesDescription(): string {
    return this.get(KEYS.FPT_FEES_DESCRIPTION);
  }

  /** @deprecated by https://invoice2go.atlassian.net/browse/PEG-3217.
   * Replaced by this.cardPayments.stripe **/
  get isUnderwritten(): boolean {
    return this.get(KEYS.KYC_COMPLETE);
  }

  get paypalEcEmail(): string {
    return this.get(KEYS.PAYPAL_EC_EMAIL);
  }

  get paypalEcEnabled(): boolean {
    return this.get(KEYS.PAYPAL_EC_ENABLED);
  }

  get paypalEcStatus(): PayPalEcStatesEnum {
    return this.get(KEYS.PAYPAL_EC_STATUS);
  }

  /** @deprecated
   * Replaced by fetching /settings/paypal_ec/onboarding **/
  get paypalOnboardingUrl(): string {
    return this.get(KEYS.PAYPAL_ONBOARDING_URL);
  }

  /** @deprecated by https://invoice2go.atlassian.net/browse/PEG-3217.
   * Replaced by this.cardPayments.stripe **/
  get underwritingCountry(): string {
    return this.get(KEYS.UNDERWRITING_COUNTRY);
  }

  get underwritingCurrency(): string {
    return this.get(KEYS.UNDERWRITING_CURRENCY);
  }

  /** @deprecated by https://invoice2go.atlassian.net/browse/PEG-3217.
   * Replaced by settingsDataStore.getUnderwritingUrl() **/
  get underwritingUrl(): string {
    return this.get(KEYS.UNDERWRITING_URL);
  }

  get cardPayments(): CardPayments {
    return this.get(KEYS.CARD_PAYMENTS);
  }

  get tipEnabled(): boolean {
    return this.get(KEYS.TIP_ENABLED);
  }

  bankTransferEnabled(): boolean {
    return this.achDebit.isEnabled();
  }

  cardPaymentsEnabled(): boolean {
    return (
      this.cardPayments &&
      this.cardPayments.stripe &&
      this.cardPayments.stripe.isEnabled()
    );
  }

  paymentsEnabled(): boolean {
    return (
      this.bankTransferEnabled() ||
      this.cardPaymentsEnabled() ||
      this.paypalEcEnabled
    );
  }
}
